import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initialMessage, userMessage } from 'constants/ui.constants';

import { IBenefit, ICompanyBenefit } from 'constants/benefits.constants';

interface IBenefitsState {
	error: userMessage;
	isLoading: boolean;
	allBenefits: IBenefit[] | null;
	companyBenefits: ICompanyBenefit[];
}

const initialState: IBenefitsState = {
	error: initialMessage,
	isLoading: false,
	allBenefits: null,
	companyBenefits: [],
};

export const benefitsSlice = createSlice({
	name: 'benefits',
	initialState,
	reducers: {
		setBenefits: (state, { payload }) => {
			state.allBenefits = payload;
		},
		setError: (state, action: PayloadAction<userMessage>) => {
			state.error = action.payload;
		},
		setLoading: (state, { payload }) => {
			state.isLoading = payload;
		},
		setCompanyBenefits: (state, { payload }) => {
			state.companyBenefits = payload;
		},
	},
});

export const getAllBenefits = (state: any) => {
	return state.benefits.allBenefits;
};
export const getError = (state: any) => {
	return state.benefits.error;
};
export const getLoading = (state: any) => {
	return state.benefits.isLoading;
};
export const getCompanyBenefits = (state: any) => {
	return state.benefits.companyBenefits;
};

export const { setBenefits, setError, setLoading, setCompanyBenefits } = benefitsSlice.actions;

export default benefitsSlice.reducer;
